import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom'; // To access the dynamic route parameter

const NewsDetailPage = () => {
  const { url } = useParams(); // Get the dynamic URL parameter (can be article URL or ID)
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        // Assuming the `url` is used to fetch the full article
        const response = await fetch(url); // Replace this with your actual API or method to get full article
        const data = await response.json();
        setArticle(data); // Set the full article data
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch the article');
        setLoading(false);
      }
    };

    fetchArticle(); // Fetch the article data when the component mounts
  }, [url]); // Re-run when `url` changes

  if (loading) {
    return <p>Loading...</p>;
  }

  if (error) {
    return <p>{error}</p>;
  }

  if (!article) {
    return <p>Article not found</p>;
  }

  return (
    <div className="news-detail">
      <h2>{article.title}</h2>
      <img src={article.image} alt={article.title} />
      <p>{article.description}</p>
      {/* Add any other article data you want to display */}
    </div>
  );
};

export default NewsDetailPage;
